module.exports = __webpack_public_path__ + "media/images/black_history_month/bg-shape-lemon-half-22cc272e59b65d4915312c06615ffebd.png";